import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
import * as React from 'react';

import {Sort} from '../../../util/queryTypes';
import {ResetColorRun, useResetColors} from './useResetColors';

export function getShouldHideRandomizeColors(
  numRows: number,
  resetRunColorsConfig: ReturnType<typeof useResetColors>
) {
  return (
    numRows < 2 || // if only one row
    (!resetRunColorsConfig.modifiedSort &&
      !resetRunColorsConfig.hasActiveFilter &&
      !resetRunColorsConfig.hasActiveSearch &&
      !resetRunColorsConfig.hasActiveGroupKeys)
  );
}

export function getShouldHideResetColors(
  resetRunColorsConfig: ReturnType<typeof useResetColors>
) {
  return !resetRunColorsConfig.hasCustomRunColors;
}

export function useShouldHideResetRunColorsSection(
  sort: Sort,
  rows: ResetColorRun[]
) {
  const resetRunColorsConfig = useResetColors({sort, rows});
  return React.useMemo(() => {
    const hideRandomizeColors = getShouldHideRandomizeColors(
      rows.length,
      resetRunColorsConfig
    );
    const hideResetColors = getShouldHideResetColors(resetRunColorsConfig);
    return hideRandomizeColors && hideResetColors;
  }, [rows.length, resetRunColorsConfig]);
}

export const ResetRunColors = ({
  sort,
  rows,
}: {
  sort: Sort;
  rows: ResetColorRun[];
}) => {
  const resetRunColorsConfig = useResetColors({sort, rows});
  const hideRandomizeColors = getShouldHideRandomizeColors(
    rows.length,
    resetRunColorsConfig
  );
  const hideResetColors = getShouldHideResetColors(resetRunColorsConfig);
  return (
    <>
      {!hideRandomizeColors && (
        <DropdownMenu.Item onSelect={resetRunColorsConfig.randomizeColors}>
          Randomize colors
        </DropdownMenu.Item>
      )}
      {!hideResetColors && (
        <DropdownMenu.Item onSelect={resetRunColorsConfig.resetColors}>
          Reset colors
        </DropdownMenu.Item>
      )}
    </>
  );
};
